export default [
  {
    path: '/popularizeB',
    name: 'popularizeB',
    component: () => import('@views/gongZhongHao/popularizeB.vue'),
    meta: {
      title: '免费发布招工信息'
    }
  },
  {
    path: '/popularizeC',
    name: 'popularizeC',
    component: () => import('@views/gongZhongHao/popularizeC.vue'),
    meta: {
      title: '每天发布招工信息'
    }
  },
  {
    path: '/popularizeG',
    name: 'popularizeG',
    component: () => import('@views/gongZhongHao/popularizeG.vue'),
    meta: {
      title: '创造就业机会提供就业保障'
    }
  }
]
